export const world = {
  USA: {
    West: {
      try: 'https://maps.app.goo.gl/GdUyyCiEWkSDn68k7',
      true: 'https://maps.app.goo.gl/mVk2X1fM5CTaevDUA',
    },
    Southwest: {
      try: 'https://maps.app.goo.gl/KHbAPscT8XfNDP9t7',
      true: 'https://maps.app.goo.gl/5YJ3X9KHpzMEwcG9A',
    },
    Southeast: {
      try: 'https://maps.app.goo.gl/KPjGoNkKFczhJ6Ru9',
      true: 'https://maps.app.goo.gl/FfaoiiyMdUiLrG578',
    },
    Midwest: {
      try: 'https://maps.app.goo.gl/URVbZNJxxZS8dhAv6',
      true: 'https://maps.app.goo.gl/GaG3Ez1M5fxuwF1Z7',
    },
    Northeast: {
      try: 'https://maps.app.goo.gl/dZSWrYwDV7aWd8tk6',
      true: 'https://maps.app.goo.gl/23kCzV2cv3dH17qo8',
    },
  },
  Cities: {
    Seattle: {
      try: 'https://maps.app.goo.gl/WLfNqHcUqg2pjDaq5',
      true: 'https://maps.app.goo.gl/iKbW6AUVrJGPvsDdA',
    },
    Portland: {
      try: 'https://maps.app.goo.gl/8dFFUkkqWvoSi7LT8',
      true: 'https://maps.app.goo.gl/DofitZJLBAtfYKxr5',
    },
    'Bay Area': {
      try: 'https://maps.app.goo.gl/kJsA7ozBnJXbnMHp6',
      true: 'https://maps.app.goo.gl/EBwtdvKbgZzLy1cy9',
    },
    NYC: {
      try: 'https://maps.app.goo.gl/yxvYgpDxAD9Df5qG6',
      true: 'https://maps.app.goo.gl/T8BRKf3dpGpqFMs89',
    },
  },
  Regional: {
    Mediterranean: {
      try: 'https://maps.app.goo.gl/SScZLsUY7bh9ZWd39',
      true: 'https://maps.app.goo.gl/1nUngVsxiVPuFhN56',
    },
    'Western Europe': {
      try: 'https://maps.app.goo.gl/zNz9kQFJSLCjqjts7',
      true: 'https://maps.app.goo.gl/3QXpRSD2g5bRAt5c6',
    },
    'South America': {
      try: 'https://maps.app.goo.gl/z81nt8U18UTBdMpD9',
      true: 'https://maps.app.goo.gl/g5pKzs1oXWDbjg6r7',
    },
    'Middle East': {
      try: 'https://maps.app.goo.gl/F1XSh94Vr4Tr2nwNA',
      true: 'https://maps.app.goo.gl/qeJYbXaMgvygL1pX9',
    },
    'Southeast Asia': {
      try: 'https://maps.app.goo.gl/tDCefWjS5YurG5iUA',
      true: 'https://maps.app.goo.gl/8toTUCQmydV3nDaW7',
    },
    'Central America': {
      try: 'https://maps.app.goo.gl/mewG8QAJomFLQgB4A',
      true: 'https://maps.app.goo.gl/dsfuyFZgsTERrdos5',
    },
  },
  'Specific Countries': {
    Australia: {
      try: 'https://maps.app.goo.gl/f4Lc3iPX924u1Gga9',
      true: 'https://maps.app.goo.gl/bHRUhtTdzEEbq5QL6',
    },
    Canada: {
      try: 'https://maps.app.goo.gl/1bWLMrp2m8PQHL7D7',
      true: 'https://maps.app.goo.gl/CrQBjJc9mgh9hi8y9',
    },
    Mexico: {
      try: 'https://maps.app.goo.gl/sgzkeRtnKR5fG4Cv6',
      true: 'https://maps.app.goo.gl/M3bNupJjTzZz8bFX7',
    },
    Japan: {
      try: 'https://maps.app.goo.gl/6yFrk5uqntvHN9vc7',
      true: 'https://maps.app.goo.gl/3txBbSpeXdCgvfpz9',
    },
  },
};
